import { Koi } from '@ksyos/koi';
import type { IServiceValidated } from './addServiceConsumerSettings';
import { serviceSchema } from './addServiceConsumerSettings';

export interface IAddCarePathServiceSupervisorSettingsValidated extends IServiceSupervisorSettingsValidated {
    isDisabled: boolean;
    profileId?: string;
}
export interface IServiceSupervisorSettingsValidated {
    sendNotificationEmployment?: boolean;
    sendNotificationPractitioner?: boolean;
    service: IServiceValidated;
}

export const serviceSupervisorSettingsAdd = Koi.object()
    .keys({
        sendNotificationEmployment: Koi.boolean().required(),
        sendNotificationPractitioner: Koi.boolean().required(),
        service: serviceSchema,
    })
    .options({ convert: true });

export const addCarePathServiceSupervisorSettingsAdd = serviceSupervisorSettingsAdd.concat(
    Koi.object().keys({
        isDisabled: Koi.boolean(),
        profileId: Koi.string().required(),
    })
);
